import React, { useEffect, useState, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import BidDialogBox from "../molecules/BidDialogBox";
import BidPlacedBox from "../molecules/BidPlacedBox";
import ProjectListLoader from "../atoms/ProjectListLoader";
import ProjectCard from "../../components/atoms/BuyerProjectCard/BidPageCard";
import Button from "../atoms/Button";
import Bid from "../organisms/BidTable";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "antd";
import useScrollToTop from "../../hooks/useScrollToTop";
import { fetchProjectById } from "../../utils/API/fetchProjectById";
import { createBid } from "../../utils/API/createBid";
import ErrorPage from "./Error";
import toast from "react-hot-toast";
import InquireConfirmation from "../molecules/HomePageDialogs/InquireConfirmation";
import { validateBid } from "../../utils/helper/Validator/bid";
import { useDispatch } from "react-redux";
import { taxationAmount } from "../../utils/API/taxationAmount";
import { bidConditions } from "../../utils/API/bidCondition";
import { LoadingOutlined } from "@ant-design/icons";

const BidPage = () => {
  useScrollToTop();
  const dispatch = useDispatch();
  const [inquireConfirmState, setInquireConfirmState] = useState(false);
  const [isBidDialogOpen, setBidDialogOpen] = useState(false);
  const [isBidPlacedOpen, setBidPlacedOpen] = useState(false);
  // const [isConditionsAccepted, setConditionsAccepted] = useState(false);
  const [bidPrice, setBidPrice] = useState(0);
  const [numberOfCredits, setNumberOfCredits] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const [bidLoading, setBidLoading] = useState(false);
  const [conditions, setConditions] = useState("");
  const navigate = useNavigate();

  const [amount, setAmount] = useState(0);
  const [gst, setGst] = useState(0);
  const [platformFee, setPlatformFee] = useState(0);
  const [remittance, setRemittance] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isBidButtonLoading, setIsBidButtonLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const userId = searchParams.get("userId");
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchProjectById(projectId, userId, dispatch);
        setNumberOfCredits(data[0].no_of_credits_to_sell);
        setBidPrice(data[0].price_per_credit);
        setProjectData(data[0]);
      } catch (err) {
        setError(err.status);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [projectId, userId]);

  const handleBidClick = async () => {
    try {
      setIsBidButtonLoading(true);
      const response = await bidConditions(projectId, dispatch);
      setConditions(response.message);
      if (response.result == true) {
        setBidDialogOpen(true);
      } else {
        // toast.success("Bid Creadted Successfully");
        handleBidDialogOk();
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setIsBidButtonLoading(false); // Stop loader
    }
  };
  const handleContinueClick = () => {
    navigate("/");
  };

  useEffect(() => {
    fetchTaxationData();
  }, [numberOfCredits, bidPrice]);

  const fetchTaxationData = async () => {
    try {
      const formData = {
        buyerOrigin: "NAT",
        sellerOrigin: "NAT",
        totalAmount: numberOfCredits * bidPrice,
      };
      const amounts = await taxationAmount(formData, dispatch);
      setAmount(formData.totalAmount);
      setGst(amounts.data.data.tax);
      setPlatformFee(amounts.data.data.platform_fee);
      setRemittance(amounts.data.data.remittance);
      const calculatedTotalAmount =
        formData.totalAmount +
        amounts.data.data.tax +
        amounts.data.data.platform_fee +
        amounts.data.data.remittance;
      setTotalAmount(calculatedTotalAmount);
    } catch (error) {
      toast.error("Error in Fetching Taxes and amounts Balance");
    } finally {
    }
  };

  const handleBidDialogCancel = () => {
    setBidDialogOpen(false);
    // setConditionsAccepted(false);
  };

  const handleBidDialogOk = async () => {
    // if (isConditionsAccepted) {
    if (numberOfCredits > projectData?.no_of_credits_to_sell) {
      setBidDialogOpen(false);
      setInquireConfirmState(true);
      // setConditionsAccepted(false);
      return;
    }
    const {
      project: { _id: projectId },
      userData: { userId },
    } = projectData;
    try {
      const { success, message } = validateBid(
        Number(bidPrice),
        Number(numberOfCredits),
        projectData?.numberOfCredits
      );
      if (!success) throw new Error(message);
      setBidLoading(true);
      const response = await createBid(
        {
          projectId,
          bidAmount: bidPrice,
          number_Of_Credits: numberOfCredits,
          creditOwner: userId,
        },
        dispatch
      );
      setBidDialogOpen(false);
      setBidPlacedOpen(true);
      // setConditionsAccepted(false);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBidLoading(false);
    }
    // } else {
    //   toast.error("Please accept the conditions before continuing.");
    // }
  };

  const handleBidPlacedCancel = () => {
    setBidPlacedOpen(false);
    navigate("/");
  };

  const handleBidPlacedOk = () => {
    setBidPlacedOpen(false);
    navigate("/my-bids");
  };

  if (error) return <ErrorPage status={error} />;

  return (
    <div className="bg-gray-100 w-full h-full p-6">
      <div className="kyc_form px-8 font-spaceGrotesk w-full bg-white rounded-2xl shadow-formShadow pb-12 h-[calc(100vh-6rem)] overflow-y-scroll no-scrollbar">
        <h1 className="ml-12 my-8 text-[28px] font-bold">Place Bid</h1>
        <div className="px-5 mt-15  mr-3">
          <div className="">
            {isLoading ? (
              <ProjectListLoader numberOfSkeletons={1} />
            ) : (
              <div className=" ml-[.8625rem] drop-shadow-lg mb-4">
                <ProjectCard
                  {...projectData}
                  actionButton={false}
                  closeBtn={true}
                />
              </div>
            )}
          </div>
        </div>
        <div className="mt-12 ">
          {isLoading ? (
            <Skeleton.Button
              block={true}
              active={true}
              className="mt-8 mb-16 px-8"
              style={{ height: "5rem", width: "100%" }}
            />
          ) : (
            <Bid
              location={`${projectData?.project?.location?.state}, ${projectData?.project?.location?.country}`}
              bidPrice={bidPrice}
              tokenType={projectData?.project?.tokenType}
              onBidPriceChange={setBidPrice}
              onCreditsChange={setNumberOfCredits}
              numberOfCredits={numberOfCredits}
              totalCredits={projectData?.numberOfCredits}
              orderPayments={true}
              amount={amount}
              gst={gst}
              platformFee={platformFee}
              remittance={remittance}
              totalAmount={totalAmount}
            />
          )}
        </div>
        <div className="w-full flex flex-col gap-3 ">
          <Button
            varient="primary"
            borderColor="blue"
            className=" mx-8 flex flex-grow py-3 text-sm justify-center text-white font-bold  bg-blue-800   "
            onClick={handleBidClick}
            disabled={isBidButtonLoading}
          >
            <div className="flex justify-center items-center">
              {isBidButtonLoading ? ( 
                <LoadingOutlined className="w-5 h-5" />
              ) : (
                  <>
                  { (numberOfCredits <= projectData?.no_of_credits_to_sell) &&   <img className="w-5 h-5" src="/images/bid.svg" alt="" />}
                  </>
              )}
              <div className="ml-2">
                {projectData &&
                numberOfCredits > projectData?.no_of_credits_to_sell
                  ? "Inquire"
                  : "Bid"}
              </div>
            </div>
          </Button>
          <Button
            varient="primary"
            borderColor="blue"
            className=" flex flex-grow py-3 text-sm text-blue-800 justify-center font-bold border-none bg-blue-200 mx-8"
            onClick={handleContinueClick}
          >
            <div className="flex justify-center">
              <div className="w-fit">
                <img className="w-5 h-5 mr-2" src="/images/arrow.svg" alt="" />
              </div>
              <div className="">Continue Surfing</div>
            </div>
          </Button>
        </div>
      </div>
      <BidDialogBox
        // isConditionsAccepted={isConditionsAccepted}
        bidLoading={bidLoading}
        open={isBidDialogOpen}
        projectId={projectId}
        onCancel={handleBidDialogCancel}
        onOk={handleBidDialogOk}
        // onConditionsAcceptedChange={setConditionsAccepted}
        conditions={conditions}
      />
      <BidPlacedBox
        open={isBidPlacedOpen}
        onCancel={handleBidPlacedCancel}
        onOk={handleBidPlacedOk}
      />
      <InquireConfirmation
        open={inquireConfirmState}
        onCancel={() => setInquireConfirmState(false)}
      />
    </div>
  );
};

export default BidPage;
